/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';

function XPDFViewer(props: any) {
  return (
    <PDFViewer width={window.innerWidth / 2} height={window.innerHeight / 1.25} showToolbar={false}>
      {props.children}
    </PDFViewer>
  );
}

export default XPDFViewer;
